import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  isDevMode,
  NgZone,
  OnInit,
  Output,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { SpeedService } from "../_service/speed.service";
import { PingService } from "../_service/ping.service";
import { DownloadService } from "../_service/download.service";
import { UploadService } from "../_service/upload.service";
import { StoreService } from "../_service/store.service";
import { IspService } from "../_service/isp.service";
import { APIService } from "../_service/api.service";
import { HelperService } from "../_service/helper.service";

import { Test } from "../_model/test";

import { DeviceDetectorService } from "ngx-device-detector";
import { TranslateService } from "@ngx-translate/core";
import { GeoLocationService } from "../_service/geolocation.service";

import { Chart } from "chart.js";
import { Subscription } from "rxjs";

import { Stability } from "../_helper/stability";

import { ISGService } from "../_service/isg.service";
import { ISGObject } from "../_model/isg-object";

@Component({
  selector: "test",
  templateUrl: "test.component.html",
  styleUrls: ["test.component.css"],
})
export class TestComponent implements OnInit {
  deviceInfo = null;
  loading: Boolean = true;
  speed: number;
  speedString: string;
  progress: number;
  max: number;
  unit: string;
  testType: string;
  ping: number;
  pingArray: number[] = [];
  download: number;
  upload: number;
  data: number;
  fred: Date;

  subHistogram: Subscription;

  errorMsg: string;
  currentLocation: any = null;

  // Download Graph
  canvasDownload: any;
  ctxDownload: any;
  chartDownload: Chart;
  rowsDownload: any[] = [];

  counter = 0;

  chartColors: any = {
    red: "rgb(255, 99, 132)",
    orange: "rgb(255, 159, 64)",
    yellow: "rgb(255, 205, 86)",
    green: "rgb(80, 250, 100)",
    blue: "rgb(52, 152, 219)",
    purple: "rgb(117, 54, 230)",
    grey: "rgb(201, 203, 207)",
    white: "rgb(255, 255, 255)",
  };

  downloadHistogram: number[];
  downloadHistogramToPlot: number[];
  uploadHistogram: number[];
  uploadHistogramToPlot: number[];

  array: number[] = [];

  private stability: Stability = new Stability();

  // ISG
  isgObject: ISGObject;
  position: any = {};
  offerConfig: any = undefined;

  set DownloadHistogram(status: number[]) {
    this.downloadHistogram = status;
    this.downloadHistogramToPlot = this.downloadHistogram.slice(0, 60);
  }

  set UploadHistogram(status: number[]) {
    this.uploadHistogram = status;
    this.uploadHistogramToPlot = this.uploadHistogram.slice(0, 60);
  }

  getInitialHistogramStatus() {
    return [];
  }

  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private speedService: SpeedService,
    private pingService: PingService,
    private downloadService: DownloadService,
    private uploadService: UploadService,
    private zone: NgZone,
    private storeService: StoreService,
    // private _config: RoundProgressConfig,
    private ispService: IspService,
    private apiService: APIService,
    private helperService: HelperService,
    private http: HttpClient,
    private deviceService: DeviceDetectorService,
    private translate: TranslateService,
    private ref: ChangeDetectorRef,
    private geoLocationService: GeoLocationService,
    private isgService: ISGService
  ) {
    // _config.setDefaults({
    //     color: '#f00',
    //     background: '#0f0',
    //     radius: 130,
    // });

    this.DownloadHistogram = this.getInitialHistogramStatus();
    this.UploadHistogram = this.getInitialHistogramStatus();
    this.downloadHistogramToPlot = this.getInitialHistogramStatus();
    this.uploadHistogramToPlot = this.getInitialHistogramStatus();

    this.pingService.progress$.subscribe((data) => {
      this.zone.run(() => {
        this.pingArray.push(data);
        translate.get("latency.testing").subscribe((res: string) => {
          this.testType = res;
        });
        this.speed = data;
        if (data) {
          this.speedString = data.toFixed(0);
        }
        this.speedString = data.toFixed(0);
        this.unit = "ms";
      });
    });

    this.downloadService.progress$.subscribe((data) => {
      this.zone.run(() => {
        translate.get("download.testing").subscribe((res: string) => {
          this.testType = res;
        });
        this.speed = data.speed;
        if (data.speed) {
          this.speedString = data.speed.toFixed(2);
        }
        this.progress = data.progress;
        this.unit = "Mbps";
      });
    });

    // Histogram

    this.downloadService.histogram$.subscribe((data) => {
      this.zone.run(() => {
        this.DownloadHistogram = data;
      });
    });

    this.uploadService.progress2$.subscribe((data) => {
      this.zone.run(() => {
        translate.get("upload.testing").subscribe((res: string) => {
          this.testType = res;
        });
        this.speed = data.speed;
        if (data.speed) {
          this.speedString = data.speed.toFixed(2);
        }
        this.progress = data.progress;
        this.unit = "Mbps";
      });
    });

    // Histogram
    this.uploadService.histogram$.subscribe((data) => {
      this.zone.run(() => {
        this.UploadHistogram = data;
      });
    });

    this.pingService.notify$.subscribe((data) => {
      this.zone.run(() => {
        if (data == "end") {
          let total = 0;
          for (let i = 0; i < this.pingArray.length; ++i) {
            total += this.pingArray[i];
          }
          const avg = total / this.pingArray.length;
          this.ping = avg;
          this.storeService.test.ping = avg;
        }
      });
    });

    this.downloadService.notify$.subscribe((data) => {
      this.zone.run(() => {
        if (data === "start") {
          this.progress = 0;
        }
        if (data === "end") {
          this.download = this.speed;
          this.storeService.test.download = this.download;
          this.storeService.test.downloadHistogram = this.downloadHistogram;
        }
      });
    });

    this.uploadService.notify$.subscribe((data) => {
      this.zone.run(() => {
        if (data == "end") {
          this.upload = this.speed;
          this.storeService.test.upload = this.upload;
          // console.log(this.storeService.test);
        }
      });
    });
  }

  setupHistograms() {
    this.DownloadHistogram = this.getInitialHistogramStatus();
    this.UploadHistogram = this.getInitialHistogramStatus();
    this.downloadHistogramToPlot = [];
    this.uploadHistogramToPlot = [];
  }

  ngOnInit() {
    this.max = 1;

    if (Object.keys(this.storeService.isp).length !== 0) {
      this.runPing();
    } else {
      this.ispService.getIsp().subscribe(
        (data) => {
          this.helperService.processIsp(data);
          this.runPing();
        },
        (error) => {
          console.log("error: ", error);
        }
      );
    }

    this.getGeolocation();

    this.loading = true;
    setTimeout(() => (this.loading = false), 200);
  }

  runPing() {
    // console.log("runPing");
    this.setupHistograms();

    this.storeService.test.testDate = new Date();
    this.pingService.ping().subscribe(
      (result) => console.log(),
      (error) => console.log(),
      () => this.runDownload()
    );
  }

  runDownload() {
    // console.log("runDownload");
    this.downloadService.download().subscribe(
      (result) => console.log(),
      (error) => console.log(),
      () => this.runUpload()
    );
  }

  runUpload() {
    // console.log("runUpload");
    const that = this;
    setTimeout(function () {
      that.uploadService.upload().subscribe(
        (result) => console.log(),
        (error) => console.log(),
        () => that.saveResults()
      );
    }, 100);

    this.runISG();
  }

  runISG() {
    if (this.getPosition().cc == "US") {
      this.isgService.get(this.getPosition()).subscribe(
        (data) => {
          this.isgObject = data;

          let generic = {
            Provider: "Generic",
            Url: "https://www.bundleyourhome.com/?igp=37975&tel=1-855-908-9120&utm_source=Etrality+GmbH&utm_medium=perf+mkt&utm_campaign=Generic+Etrality+GmbH",
            Phone: "1-855-908-9120",
          };

          var city = this.isgObject.dslCable.City;
          if (this.isgObject.fiber.City) {
            city = this.isgObject.fiber.City;
          }
          if (this.isgObject.satellite.City) {
            city = this.isgObject.satellite.City;
          }

          this.offerConfig = {
            styles: {
              backgroundColor: "#36D986",
              marginTop: "10px",
              letterSpacing: "-0.2px",
              width: "90%",
            },
            icon: "fa fa-phone",
            text: "Call us today and save",
            generic: generic,
            city: city,
            dslCable: this.isgObject.dslCable.Provider
              ? this.isgObject.dslCable
              : undefined,
            fiber: this.isgObject.fiber.Provider
              ? this.isgObject.fiber
              : undefined,
            satellite: this.isgObject.satellite.Provider
              ? this.isgObject.satellite
              : undefined,
          };

          this.storeService.isgOffer = this.offerConfig;
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  getPosition(): any {
    let test = this.storeService.test;
    let isp = test.isp;
    let geolocation = test.geolocation;

    var position = {
      src: "ip",
      lat: undefined,
      lon: undefined,
      acc: undefined,
      city: undefined,
      region: undefined,
      cc: undefined,
    };

    if (this.currentLocation) {
      // lat, lon, acc will be coming from browser geolocation API, while city, region, cc will be coming from API
      position.src = "web";
      position.lat = this.currentLocation.coords.latitude;
      position.lon = this.currentLocation.coords.longitude;
      position.acc = this.currentLocation.coords.accuracy;
    }

    if (isp) {
      position.city = isp.city;
      position.region = isp.regionName;
      position.cc = isp.countryCode;
    }

    return position;
  }

  saveResults() {
    const that = this;
    const test: Test = this.storeService.test;
    test.serverId = this.storeService.testServer.id;

    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    if (currentUser) {
      const userId: number = currentUser.id;
      test.userId = userId;
    }

    if (this.currentLocation) {
      const object: any = {
        source: "web",
        location: {
          accuracy: this.currentLocation.coords.accuracy,
          altitude: this.currentLocation.coords.altitude,
          altitudeAccuracy: this.currentLocation.coords.altitudeAccuracy,
          heading: this.currentLocation.coords.heading,
          latitude: this.currentLocation.coords.latitude,
          longitude: this.currentLocation.coords.longitude,
          speed: this.currentLocation.coords.speed,
        },
      };

      test.geolocation = object;
    }

    this.storeService.test.downloadStability =
      this.stability.calculateStandardDeviation(
        this.storeService.test.downloadHistogram
      );
    this.storeService.test.uploadStability =
      this.stability.calculateStandardDeviation(
        this.storeService.test.uploadHistogram
      );
    test.downloadStability = this.storeService.test.downloadStability;
    test.uploadStability = this.storeService.test.uploadStability;

    test.testType = "ManualTest";
    test.provider = "w-sc-1";
    if (isDevMode()) {
      console.log("isDevMode: enabled");
      test.provider = "w-sc-1-dev";
    }
    test.version = "1.0.0";
    this.deviceInfo = this.deviceService.getDeviceInfo();
    test.os = this.deviceInfo["browser"];
    test.osVersion = this.deviceInfo["browser_version"];
    test.deviceInfo = this.deviceInfo;
    this.apiService.saveTest(test).subscribe(
      (result) => {
        that.storeService.test.id = result["id"];
        const tests: Test[] = that.getTestLocalStorage();
        tests.push(test);
        that.setTestLocalStorage(tests);
        that.next();
      },
      (error) => console.log(error)
    );
  }

  next() {
    const that = this;
    setTimeout(function () {
      that.notify.emit("end");
    }, 120);
  }

  getTestLocalStorage(): Test[] {
    const localStorageItem = JSON.parse(localStorage.getItem("tests"));
    return localStorageItem == null ? [] : localStorageItem.tests;
  }

  private setTestLocalStorage(tests: Test[]) {
    localStorage.setItem("tests", JSON.stringify({ tests: tests }));
  }

  private getGeolocation() {
    const self = this;
    const accuracy = {
      enableHighAccuracy: true,
    };
    self.geoLocationService.getLocation(accuracy).subscribe(
      function (position) {
        self.currentLocation = position;
        self.ref.detectChanges();
      },
      function (error) {
        self.errorMsg = error;
        self.ref.detectChanges();
      }
    );
  }
}
